var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",style:({
    zIndex: _vm.props.zIndex,
    backgroundColor: _vm.props.bgColor,
  }),on:{"click":_vm.click,"tap":_vm.tap}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.innerContentClick.apply(null, arguments)}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }